'use client'

import { useState, useEffect } from 'react'

const TwoColumnSwitch = ({ options, onChange, addClass='', defaultId=null, height=9, textSize="text-sm"}) => {
  const [selected, setSelected] = useState(defaultId || options[0].id)
  // 初期選択状態を通知
  useEffect(() => {
    onChange(selected)
  }, [selected, onChange])

  const handleChange = (value) => {
    setSelected(value)
    onChange(value)
  }

  return (
    <div className={`relative h-${height} w-32 rounded-full bg-white border border-gray-200 shadow-sm p-[1px] ${addClass}`}>
      {/* 背景のインジケーター */}
      <div
        className={`
          absolute h-${height - 1} w-[calc(50%-0.25rem)] rounded-full bg-[#49495b] transition-transform duration-200 ease-in-out
          ${selected === options[0].id ? 'left-1' : 'left-[calc(50%+0.125rem)]'}
        `}
      />

      {/* ボタングループ */}
      <div className="relative flex h-full">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => handleChange(option.id)}
            className={`
              flex-1 ${textSize} font-medium transition-colors duration-200 ease-in-out z-10
              ${selected === option.id ? 'text-white' : 'text-gray-600 hover:text-gray-800'}
            `}
            aria-pressed={selected === option.id}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TwoColumnSwitch
